// utils/actionSheet.js
import Vue from 'vue'

class ActionSheetService {
    constructor() {
        this.instance = null
    }
    show(options) {
        // 如果已有实例，先销毁
        if (this.instance) {
            this.hide()
        }
    return new Promise((resolve, reject) => {
      // 动态创建 Vue 组件
      const ActionSheetComponent = Vue.extend({
        template: `
          <div v-if="visible" class="global-action-sheet">
            <div class="action-sheet-mask" @click="cancel"></div>
            <div class="action-sheet-content">
              <div v-if="options.title" class="action-sheet-title">{{ options.title }}</div>
              <div class="action-sheet-list">
                <div 
                  v-for="(action, index) in options.actions" 
                  :key="index"
                  class="action-item"
                  @click="select(action)"
                >
                  {{ action.name }}
                  <span v-if="action.subname" class="subname">{{ action.subname }}</span>
                </div>
              </div>
              <div class="action-cancel" @click="cancel">取消</div>
            </div>
          </div>
        `,
        data() {
          return {
            visible: false,
            options: options
          }
        },
        methods: {
          select(action) {
            this.visible = false
            setTimeout(() => {
              resolve(action)
              this.destroy()
            }, 300)
          },
          cancel() {
            this.visible = false
            setTimeout(() => {
              reject(new Error('用户取消'))
              this.destroy()
            }, 300)
          },
          destroy() {
            if (this.$el && this.$el.parentNode) {
              this.$el.parentNode.removeChild(this.$el)
            }
            this.$destroy()
          }
        },
        mounted() {
          this.visible = true
        }
      })
      
      // 创建实例并挂载
      this.instance = new ActionSheetComponent()
      const el = this.instance.$mount().$el
      document.body.appendChild(el)
    })
  }
  
  hide() {
    if (this.instance) {
      this.instance.cancel()
      this.instance = null
    }
  }
}

// 创建单例
const actionSheetService = new ActionSheetService()

// 挂载到 Vue 原型
Vue.prototype.$actionSheet = actionSheetService

// 导出单独使用
export default actionSheetService